import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Data, RouterStateSnapshot} from '@angular/router';
import {environment} from 'src/environments/environment';
import {MixpanelService} from 'app/core/services/mixpanel.service';
import {RouterHelperService} from 'app/core/services/router-helper.service';
import {urlWithoutParams} from 'app/core/url/app-urls.service';

export interface MixpanelGuardData extends Data {
    eventName: string;
}

@Injectable()
export class MixpanelGuard {
    constructor(
        private mixpanel: MixpanelService,
        private routerHelper: RouterHelperService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!next.data.eventName && !environment.production) {
            console.warn(`[MixpanelGuard] 'eventName' is required in route data`);
        }

        if (this.isSameUrl(next, state)) {
            return true;
        }

        if (next.data.eventName) {
            this.mixpanel.track(next.data.eventName);
        }
        return true;
    }

    isSameUrl(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return urlWithoutParams(this.routerHelper.getPreviousPath()) === urlWithoutParams(state.url);
    }
}
